
<!-- Modal -->
<div class="modal fade" *ngIf="adminApi.isLoggedIn()" id="{{modalid}}" tabindex="-1" aria-labelledby="suggestskillModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-md">
    <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Confirm</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <p *ngIf="table=='users'">Are you sure you want to change user status?</p>
          <p *ngIf="table!='users'">Are you sure you want to delete the entry?</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary me-3" data-bs-dismiss="modal">No</button>
          <button type="button" class="btn btn-dark btn-gold" (click)="onSubmit()">Yes <i *ngIf="submitting" class="fa fa-spinner fa-spin"></i></button>
        </div>
    </div>
  </div>
</div>